import { formatData } from 'utils/functions';

export default formatData([
  'Administrator', 'Educator', 'Parent', 'Other'
])